import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppRouter } from './components/AppRouter';
import './index.css';
import { fehlerprotokollStarten } from './lib/fehlerprotokoll';

// Merkt sich die letzten Fehler im Browser, damit eine Meldung über "Feedback"
// zeigen kann, was kurz vorher schief lief.
fehlerprotokollStarten();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppRouter>
      <App />
    </AppRouter>
  </StrictMode>
);
